import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about", id: "nav-about-link" },
  { label: "Offerings", href: "#offerings", id: "nav-offerings-link" },
  { label: "Contact", href: "#contact", id: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 bg-alabaster/80 backdrop-blur-xl border-b border-foreground/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" onClick={(e) => go(e, "#hero")} className="font-serif text-xl tracking-tight">
          Brew <span className="italic text-matcha">&amp;</span> Co.
        </a>
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.id} onClick={(e) => go(e, l.href)}
              className="font-mono text-[11px] uppercase tracking-widest text-espresso/70 hover:text-espresso transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <a href="#contact" data-testid="nav-book-button" onClick={(e) => go(e, "#contact")}
            className="rounded-full bg-espresso text-alabaster font-mono text-[11px] uppercase tracking-widest px-5 py-2.5 hover:bg-matcha transition-colors duration-300">
            Book the cart
          </a>
        </nav>
        <button data-testid="nav-mobile-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden overflow-hidden border-t border-foreground/10 bg-alabaster/95"
            aria-label="Mobile"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <a key={l.href} href={l.href} data-testid={`${l.id}-mobile`} onClick={(e) => go(e, l.href)}
                  className="font-serif text-2xl">{l.label}</a>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
